export default "__VITE_ASSET__3ff95b2e__"